import styled from 'styled-components'

export const ImageBox = styled.div`
  width: 6.25rem;
  height: 6.25rem;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  border-radius: 0.25rem;

  > img {
    aspect-ratio: 1/1;
    object-fit: fill;
  }

  .sticker {
    right: 0.25rem;
    bottom: 0.25rem;
  }
`

ImageBox.displayName = 'ImageBox'

export const InfoBox = styled.div`
  max-width: calc(100% - 7.25rem);
`

InfoBox.displayName = 'InfoBox'

export const Item = styled.div`
  gap: 1rem;
`

Item.displayName = 'Item'
